import getTT from 'getTT';
import classnames from 'classnames';
import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router, Switch, Route, Link, withRouter } from 'react-router-dom';
import { Row, Col } from 'antd';
import routerCfg from 'routerCfg';
import styles from './style.scss?__local';

const navList = [
  {
    text: '首页',
    path: routerCfg.path.home,
  },
  {
    text: '我的',
    path: routerCfg.path.i,
  },
  {
    text: '账单',
    path: routerCfg.path.fee,
  },
  {
    component: <a href="//dev.huya.com" target="_blank" rel="noopener noreferrer" className={styles['header-nav-link']}>关于小程序</a>,
  },
]

function isActivePath(currentRoutePath, itemPath) {
  if (itemPath === '/') {
    return currentRoutePath === '/'
  }

  return currentRoutePath.startsWith(itemPath)
}

function Render({ pending, isLogged, userAvatar, userNick, onEvent, currentRoutePath }) {
  return (
    <div className={styles.header}>
      <Row type="flex" justify="center">
        <Col span={22}>
          <div className={styles['header-content']}>
            <div className={styles['header-logo']}>
              <Link to={routerCfg.path.home} className={styles.logo}>
                <img src="https://a.msstatic.com/huya/main/img/logo.png" />
                <span>小程序商店</span>
              </Link>
            </div>

            <div className={styles['header-nav']}>
              {
                navList.map((item, index) => (
                  <div className={classnames(styles['header-nav-item'], { [styles['header-nav-item-on']]: isActivePath(currentRoutePath, item.path) })} key={index}>
                    {item.component || <Link className={styles['header-nav-link']} to={item.path}>{item.text}</Link>}
                  </div>
                ))
              }
            </div>

            {!pending && (
              <div className={styles['header-loginControl']}>
                <a href="//ext.huya.com/#/" target="_blank" rel="noopener noreferrer" className={styles['header-develop']}>开发者中心</a>
                {/* <a href="//github.com/huya-ext" target="_blank" rel="noopener noreferrer" className={styles['header-github']}>Github</a> */}
                {isLogged ? (
                  <div className={styles['header-loggedIn']}>
                    <Link className={styles.user} to={routerCfg.path.i}>
                      <img className={styles.avatar} src={userAvatar} />
                      <span className={styles.nick}>{userNick}</span>
                    </Link>
                    <span className={styles.logout} onClick={() => {
                      onEvent('logout')
                    }}>[ 退出 ]</span>
                  </div>
                ) : (
                  <div className={styles['header-loggedOut']}>
                    <div className={styles.login} onClick={() => {
                      onEvent('login')
                    }}><i></i><span>登录</span></div>
                    <i className={styles.l}>|</i>
                    <span className={styles.reg} onClick={() => {
                      onEvent('register')
                    }}>注册</span>
                  </div>
                )}
              </div>
            )}
          </div>
        </Col>
      </Row>
    </div>
  )
}

function Header(props) {
  const [state, setState] = useState({
    pending: true,
    isLogged: false,
    userAvatar: '',
    userNick: '',
  })

  useEffect(() => {
    if (state.pending) {
      getTT(TT => {
        TT.getUserInfo(data => {
          setState({
            pending: false,
            isLogged: data.uid != 0,
            userAvatar: data.userLogo,
            userNick: data.userNick,
          })
        })
      })
    }
  }, [])

  function handlerEvent(evtName) {
    switch (evtName) {
      case 'logout':
        getTT(TT => {
          TT.login.logout()
        });
        break;

      case 'login':
        getTT(TT => {
          TT.login.login()
        });
        break;

      case 'register':
        getTT(TT => {
          TT.login.register()
        });
        break;
    }
  }

  return <Render {...state} onEvent={handlerEvent} currentRoutePath={props.location.pathname} />
}

export default withRouter(props => <Header {...props} />)
